<script>
import { Checkbox, CheckboxGroup } from 'ant-design-vue';
export default {
  emits: ['groupChange', 'change'],
  components: { Checkbox, CheckboxGroup },
  props: {
    isGrouped: {
      type: Boolean,
      Default: false,
    },
    checked: {
      type: Boolean,
      default: false,
    },
    options: {
      type: Array,
      default: () => [],
    },
    value: {
      type: String,
      default: '',
    },
    indeterminate: {
      type: Boolean,
      default: false,
    },
    groupValues: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<template>
  <div>
    <CheckboxGroup
      v-if="isGrouped"
      :options="options"
      :value="groupValues"
      @change="(event) => $emit('groupChange', event)"
    />
    <!-- TODO: checkbox feature needs to be developed -->
    <Checkbox
      v-else
      :checked="checked"
      :indeterminate="indeterminate"
      @change="(event) => $emit('change', event.target.checked)"
      :disabled="disabled"
    >
      <slot />
    </Checkbox>
  </div>
</template>

<style lang="scss" scoped></style>
